const globalData = {
  //高奇点
  positionUrl: 'https://www.jichujiaoyu.tech/ivy/images', // 后台返回图片路径前缀
  downLoadPdf: 'https://www.jichujiaoyu.tech/ivy/data/paper/', // 后台下载pdf地址
  positdownload: 'https://www.jichujiaoyu.tech/ivy/download/', // 后台下载excel地址
  trackUrl: "https://www.jichujiaoyu.tech/ivy/images/paper/pen.track/", //蓝牙笔迹图片前缀
  trackUrlItem: "https://www.jichujiaoyu.tech/ivy/images/paper/question.track/", //蓝牙笔迹图片前缀(某一小题的）
  api: 'https://www.jichujiaoyu.tech/api', // 请求服务器的地址
  paperImage: 'https://www.jichujiaoyu.tech/ivy/images/paper/question.image/',
  booksUrl: 'https://www.jichujiaoyu.tech/ivy/data/paper/images/', //教辅
  fileUrl: 'https://www.jichujiaoyu.tech/ivy/data',// 视频前缀

  //奇点家校
  // positionUrl: 'https://www.yicheyilu.com.cn/ivy/images', // 后台返回图片路径前缀
  // downLoadPdf: 'https://www.yicheyilu.com.cn/ivy/data/paper/', // 后台下载pdf地址
  // positdownload: 'https://www.yicheyilu.com.cn/ivy/download/', // 后台下载excel地址
  // trackUrl: "https://www.yicheyilu.com.cn/ivy/images/paper/pen.track/", //蓝牙笔迹图片前缀(一页的）
  // trackUrlItem: "https://www.yicheyilu.com.cn/ivy/images/paper/question.track/", //蓝牙笔迹图片前缀(某一小题的）
  // api: 'https://www.yicheyilu.com.cn/api', // 请求服务器的地址
  // paperImage: 'https://www.yicheyilu.com.cn/ivy/images/paper/question.image/',
  // booksUrl: 'https://www.yicheyilu.com.cn/ivy/data/paper/images/', //教辅
  // fileUrl: 'https://www.yicheyilu.com.cn/ivy/data',// 视频前缀


  //C--端请求
  // positionUrl: 'https://www.yicheyilu.com.cn/cactus/images', // 后台返回图片路径前缀
  // downLoadPdf: 'https://www.yicheyilu.com.cn/cactus/data/paper/', // 后台下载pdf地址
  // positdownload: 'https://www.yicheyilu.com.cn/cactus/download/', // 后台下载excel地址
  // trackUrl: "https://www.yicheyilu.com.cn/cactus/images/paper/pen.track/", //蓝牙笔迹图片前缀(一页的）
  // trackUrlItem: "https://www.yicheyilu.com.cn/cactus/images/paper/question.track/", //蓝牙笔迹图片前缀(某一小题的）
  // api: 'https://www.yicheyilu.com.cn/api/cactus', // 请求服务器的地址
  // paperImage: 'https://www.yicheyilu.com.cn/cactus/images/paper/question.image/',
  // booksUrl: 'https://www.yicheyilu.com.cn/cactus/data/paper/images/', //教辅
  // fileUrl: 'https://www.yicheyilu.com.cn/cactus/data',// 视频前缀
};
export default globalData



// WEBPACK FOOTER //
// ./src/common/Global.js